/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "D7898185-A43A-4641-9D17-399C4930EE7E",
  "sitecoreApiHost": "",
  "jssAppName": "consumer",
  "defaultLanguage": "en",
  "graphQLEndpointPath": "/api/consumer",
  "graphQLEndpoint": "/api/consumer?sc_apikey=D7898185-A43A-4641-9D17-399C4930EE7E"
};